const hostname = window.location.hostname;
const protocol = window.location.protocol;

export const isLocal = 
    hostname === 'localhost' || 
    hostname === '127.0.0.1' || 
    hostname.startsWith('192.168.') || 
    hostname.startsWith('10.') ||
    hostname.endsWith('.local');

const HOSTED_BASE_URL = 'https://api.arikarino.com/magic-idle';


export const CONFIG = {
    API_BASE_URL: (() => {
        console.log(isLocal);
        if (isLocal) {
            return `${protocol}//${hostname}:3000/magic-idle`;
        }
        
        return HOSTED_BASE_URL;
    })(),

    ENDPOINTS: {
        SAVE: '/save',
        LOAD: '/load',
        GENERATESPELL: '/spells/generateSpell' 
    }
};